module.exports.callIfRouteMatch = function (routePattern, callback) {
  const re = new RegExp(routePattern);
  const result = re.exec(window.location.pathname);

  if (result && result[0] !== '') {
    callback();
    return true;
  }

  return false;
};
